import React, { useState, useEffect} from 'react';

const EnglishLink = ({ link, children,style, tabindex, onclick }) => {
    
    const [anchorHREF, setHREF] = useState(null);

    useEffect(() => {
        setHREF(link);
      },[]);

    return (
        <a 
        href={anchorHREF}
        onClick={onclick}
        tabIndex={tabindex}
        className={style}
        >
            {children}
        </a>
    )
}

export default EnglishLink;